import React, { useRef, useState, useEffect } from "react";
import useOutSideAlerter from "../hooks/useOutsideAlerter";
import { useNavigate, useNavigationType, useLocation } from "react-router-dom";
import "./DetailViewModal.css";
import ToggleBookmarkContainer from "../components/ToggleBookmarkContainer";
import BackArrow from "../icons/iconComponents/BackArrow";
import SvgSummaryText from "../icons/iconComponents/TextMining";
import SvgShareIcon from "../icons/iconComponents/ShareIcon.js";
import SvgNoteIcon from "../icons/iconComponents/NoteIcon";
import SvgNote from "../icons/iconComponents/Note";
import ContentBoxWrapper from "../components/ContentBoxWrapper";
import { NoteModal, ShareModal } from "../components/Modal";
import NoteNav from "../components/NoteNav";
// import parse from "html-react-parser";
import { updateLocalSetting } from "../Environment";
import { useTheme } from "../contexts/ThemeContext";
import { timeDifferenceForDate } from "../utils";
import FullSpanNoteModal from "./FullSpanNoteModal";
import FullSpanShareModal from "./FullSpanShareModal";
import { useMediaQuery } from "react-responsive";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { Parser } from "html-to-react";
import sanitizeHtml from "sanitize-html";

import { act } from "react-dom/test-utils";
// const HtmlToReactParser = require('html-to-react').Parser;
// const htmlToReactParser = new HtmlToReactParser();

function DetailViewModal(props) {
    const [isActivated, setIsActivated] = useState(props.isModalActive);
    const [isSummary, setIsSummary] = useState(false);
    const [isShareModalActive, setIsShareModalActive] = useState(false);
    const [selectedText, setSelectedText] = useState("");
    const [isNoteModalActive, setIsNoteModalActive] = useState(false);
    const [isNoteNavActive, setIsNoteNavActive] = useState(false);
    const theme = useTheme();

    // let [filterString, setFilterString] = useState("");
    const navigate = useNavigate();
    const naviType = useNavigationType();
    const routeLocation = useLocation();

    const { isFullSpanNoteModalActivated, isFullSpanShareModalActivated } =
        props.settings;
    const { is_premium, payment_status } = props.user;
    const user = props.user;

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    // const reactElement = htmlToReactParser.parse(props.postBodyHtml);
    useEffect(() => {
        const handlePopState = (event) => {
            props.setIsModalActive(false);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    // useEffect(() => {
    //     if (naviType === "POP" && routeLocation.key !== "default") {
    //         // props.setIsModalActive(false);
    //         console.log(naviType);
    //     }
    // }, [navigate]);

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    function onGetSummaryClick(e) {
        e.preventDefault();
        if (payment_status === "active" || payment_status === "trialing") {
            setIsSummary(!isSummary);
        } else if (payment_status === "past_due") {
            navigate("/complete-payment");
        } else {
            navigate("/upgrade");
        }
    }

    function onShareClick(e) {
        e.preventDefault();
        setIsShareModalActive(true);
        if (isSmallScreen) {
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(true, "isFullSpanShareModalActivated");
            });
        }
    }

    function onNoteClick(e) {
        e.preventDefault();
        // if (isPremium) {
        // 	setIsNoteModalActive(true);
        // } else {
        // 	navigate("/upgrade");
        // }

        if (payment_status === "active" || payment_status === "trialing") {
            setIsNoteModalActive(true);
            setIsNoteNavActive(true);
            if (isSmallScreen) {
                commitLocalUpdate(environment, (store) => {
                    const record = store.getRoot().getLinkedRecord("settings");
                    record.setValue(true, "isFullSpanNoteModalActivated");
                });
            }
        } else if (payment_status === "past_due") {
            navigate("/complete-payment");
        } else {
            navigate("/upgrade");
        }
    }

    function handleMouseUp(e) {
        e.preventDefault();
        setSelectedText(window.getSelection().toString());
    }

    let isOpen = isActivated ? "open" : "close";
    let isHidden = isActivated ? "" : "inactive";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode == 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        // commitLocalUpdate(environment, store => {
        // 	const record = store.getRoot().getLinkedRecord("settings");
        // 	record.setValue(filterString, "filterTerms");
        // });

        props.setIsModalActive(false);
    }

    function onChange(e) {
        e.preventDefault();
        // setFilterString(e.target.value);
        // console.log(filterString);
    }

    function onNoteToggleClick(e) {
        e.preventDefault();
        setIsNoteNavActive(!isNoteNavActive);
        updateLocalSetting("isNoteNavActivated", !isNoteNavActive);
    }

    let noteNavVisible = localStorage.getItem("Settings.isNoteNavActivated");

    return (
        <div
            className={`detailview-modal-container detailview-modal-container-${isOpen} theme-${theme.light}`}
        >
            <div className={`theme-${theme.light} detailview-wrapper`}>
                <NoteNav
                    user={props.user}
                    isActivated={isNoteNavActive}
                    settings={props.settings}
                    postId={props.postId}
                />
                <div className={`detailview-header theme-${theme.light}`}>
                    <div
                        className={`theme-${theme.light} theme-${
                            theme.border + "-true"
                        } detailview-header-room theme-${theme.light}`}
                    >
                        <BackArrow
                            className={`detailview-backarrow detailview-header-icon`}
                            onClick={onCloseClick}
                        />
                        <div className="detailview-header-icons">
                            <SvgNoteIcon
                                onClick={onNoteToggleClick}
                                className="icon"
                                size="1.7rem"
                            />
                            <SvgNote onClick={onNoteClick} size={24} />
                            <ToggleBookmarkContainer
                                postId={props.postId}
                                user={props.user}
                                settings={props.settings}
                            />
                            <SvgShareIcon onClick={onShareClick} size={24} />
                            <SvgSummaryText
                                onClick={onGetSummaryClick}
                                size={24}
                            />
                        </div>
                        <div></div>
                    </div>
                </div>
                <div
                    className={`detailview-content detailview-content-${isNoteNavActive}`}
                >
                    <div className={`detailview-content-matter`}>
                        <div className="detailview-post-main">
                            <div
                                className={`theme-${theme.foreground} detailview-post-title`}
                            >
                                <h1> {props.postTitle}</h1>

                                <h4
                                    className={`created theme-${theme.paragraph}`}
                                >
                                    {props.sourceName} {" / "}
                                    {timeDifferenceForDate(props.postCreated)}
                                </h4>
                            </div>
                            <div>
                                <img
                                    className={`detailview-image`}
                                    src={props.postImageURL}
                                />
                            </div>
                        </div>
                        {isSummary ? (
                            <div className={`detailview-post-body`}>
                                <ContentBoxWrapper
                                    settings={props.settings}
                                    user={props.user}
                                    content={props.postBody}
                                    postId={props.postId}
                                />
                            </div>
                        ) : (
                            <div
                                onMouseUp={handleMouseUp}
                                className={`theme-${theme.paragraph} detailview-post-body`}
                            >
                                {Parser().parse(
                                    sanitizeHtml(props.postBodyHtml)
                                )}
                                {/* <iframe srcDoc={props.postBodyHtml} frameBorder="0" width="1200" height="800"> */}
                                {/* </iframe> */}
                            </div>
                        )}
                        {isSmallScreen ? (
                            <div>
                                {isShareModalActive ? (
                                    <div>
                                        {isFullSpanShareModalActivated ? (
                                            <div>
                                                <FullSpanShareModal
                                                    isActivated={true}
                                                    postLink={props.postLink}
                                                    postTitle={props.postTitle}
                                                    user={user}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                {isNoteModalActive ? (
                                    <div className="note-container">
                                        {isFullSpanNoteModalActivated ? (
                                            <div>
                                                <FullSpanNoteModal
                                                    title="Note"
                                                    actionButton="Save"
                                                    setIsModalActive={
                                                        setIsNoteModalActive
                                                    }
                                                    isModalActive={
                                                        isNoteModalActive
                                                    }
                                                    postId={props.postId}
                                                    rowContent={selectedText}
                                                    isDetailView={true}
                                                    user={user}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div>
                                {isShareModalActive ? (
                                    <div>
                                        <ShareModal
                                            title="Share"
                                            setIsModalActive={
                                                setIsShareModalActive
                                            }
                                            isModalActive={isShareModalActive}
                                            postLink={props.postLink}
                                            postTitle={props.postTitle}
                                            user={user}
                                        />
                                    </div>
                                ) : null}
                                {isNoteModalActive ? (
                                    <div className="note-container">
                                        <NoteModal
                                            title="Note"
                                            actionButton="Save"
                                            setIsModalActive={
                                                setIsNoteModalActive
                                            }
                                            isModalActive={isNoteModalActive}
                                            postId={props.postId}
                                            rowContent={selectedText}
                                            isDetailView={true}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        )}
                        <div className="external-link-container">
                            <a
                                className={`external-page-link theme-${theme.foreground}`}
                                target="_blank"
                                href={props.postLink}
                            >
                                {"Read more on: "} {props.sourceName}
                            </a>
                        </div>{" "}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DetailViewModal;
